import filterPanel from '../assets/elements/filterPanel';
import { saveCurrentState } from "./listChanging";

function saveSettingsToLocalStorage(currentSettings, newThemeName = "Default") {

    const saveKeyToCurrentSettings = (itemSettings, targetSettings) => {
        for (const key in itemSettings){
            if(itemSettings.hasOwnProperty(key)){
                const setting = itemSettings[key]
                targetSettings[key]=setting
            }
        }
    }

    const checkElementsSettings = (settingsAccumulator) => {
        
        const productListBodyElements = JSON.parse(localStorage.getItem('onlineCreatorB2B-productListBody'));
        const mainBodyElements = JSON.parse(localStorage.getItem('onlineCreatorB2B-mainBody'));
        const cartBodyElements = JSON.parse(localStorage.getItem('onlineCreatorB2B-cartBody'));
        const leftColumnElements = JSON.parse(localStorage.getItem('onlineCreatorB2B-column'));

        if(productListBodyElements!==null && mainBodyElements!==null && cartBodyElements!==null && leftColumnElements!==null){
            const pageElements = productListBodyElements.concat(mainBodyElements, cartBodyElements);
            pageElements.forEach((item) => {
                if (!item.hasOwnProperty('settings') || item.type === "mainBanner" || item.type === "popupBanner" || item.type === "promotionalBanner") {
                    return;
                }
                if(item.id==="filterPanel-1" && leftColumnElements.length===1){
                    leftColumnElements.push(filterPanel[0].column)
                    localStorage.setItem("onlineCreatorB2B-column", JSON.stringify(leftColumnElements));
                    saveCurrentState.call(this, 'column', leftColumnElements, '');
    
                }
                if(item.id==="filterPanel-2" && leftColumnElements.length===2){
                    leftColumnElements.pop()
                    localStorage.setItem("onlineCreatorB2B-column", JSON.stringify(leftColumnElements));
                    saveCurrentState.call(this, 'column', leftColumnElements, '');
                }
                const itemSettings = JSON.parse(item.settings); 
                
                saveKeyToCurrentSettings.call(this, itemSettings, settingsAccumulator);
            });
    
        }
        
        return settingsAccumulator;
    }

    checkElementsSettings.call(this, currentSettings);
    const settings = JSON.stringify(currentSettings);
    const currentThemeName= JSON.stringify(newThemeName);
    localStorage.setItem(this.prefix+"settings", settings);
    localStorage.setItem(this.prefix+"currentThemeName", currentThemeName);

}

export default saveSettingsToLocalStorage;